'use client';

import { Center, Stack } from '@chakra-ui/react';

import { NextLinkButton, SiteShell } from '@/modules/navigation/presentation';

const Error = () => {
	return (
		<SiteShell>
			<Center>
				<Stack gap={4}>
					Something went wrong!
					<NextLinkButton href="/">Go Back</NextLinkButton>
				</Stack>
			</Center>
		</SiteShell>
	);
};

export default  Error;
